<template>
  <div class="required login">
    <div class="logo-wrapper"></div>
    <el-card class="login-form-layout lg:w-1/3 md:w-1/2">
      <el-form autoComplete="off" class="my-5 mx-6" :model="loginForm" :rules="loginRules" ref="loginForm"  label-position="left">
        <h2 class="login-title">找回密码</h2>
        <div class="flex justify-center mt-5 mb-8">
          <el-radio-group v-model="loginForm.method" @change="methodChange" size="medium" fill="#123B7F">
            <el-radio-button :label="1">通过手机号</el-radio-button>
            <el-radio-button :label="2">通过邮箱</el-radio-button>
          </el-radio-group>
        </div>
        <div v-if="loginForm.method==1">
          <el-form-item prop="phone">
            <el-input name="phone" type="text" v-model="loginForm.phone" autoComplete="off" placeholder="请输入手机号">
            <span slot="prefix">
              <svg-icon icon-class="user" class="color-main"></svg-icon>
            </span>
            </el-input>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item prop="email">
            <el-input name="email" type="text" v-model="loginForm.email" autoComplete="off" placeholder="请输入邮箱">
            <span slot="prefix">
              <svg-icon icon-class="user" class="color-main"></svg-icon>
            </span>
            </el-input>
          </el-form-item>
        </div>

        <el-form-item label-width="0" class="mt-20">
          <el-button class="goBackBtn" style="width:47%;" @click="goBack" size="medium">
            返回
          </el-button>
          <el-button style="width:47%;margin-left:6%;background-color: #123B7F;color:#FFF;" @click="handleNext()" size="medium">
            下一步
          </el-button>
        </el-form-item>


      </el-form>

    </el-card>
  </div>
</template>

<script>

export default {
  name: "findPassword",
  data(){
    const checkphone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (value.length!=11) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      loginForm:{
        method:1,
        phone:"",
        email:"",
      },
      loginRules: {
        phone:[{required: true, trigger: 'blur', validator: checkphone}],
        email:[
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
    }
  },
  methods:{
    //登录方式单选事件
    methodChange(val){
      if(val===1){
        this.loginForm.email="";
      }else{
        this.loginForm.phone="";
      }
      this.$refs["loginForm"].resetFields();
      this.method = val;
    },
    handleNext(){
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$router.push({
            name: 'resetPassword',
            params:{
              loginForm:this.loginForm
            }
          });
        } else {
          this.$message('参数验证不合法！');
          return false
        }
      })
    },
    //返回上一页
    goBack(){
      this.$router.push({
        path: '/login'
      });
    },
  }
}
</script>

<style scoped>
.login {
  position: relative;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/login_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
}
.login-form-layout {
  position: absolute;
  left: 0;
  right: 0;
  /*width: 28rem;*/
  margin: 140px auto;
}
.login-title {
  font-size: 1.875rem;
  font-weight: bold;
  color: #333333;
  letter-spacing: 2px;
  text-align: center;
}
.color-main{
  color: #123B7F;
}
/deep/ .el-input__inner:focus{
  border-color: #123B7F;
}
/deep/ .el-radio-button__inner:hover{
  color: #123B7F;
}
/deep/ .el-input__inner {
  /*width: 220px;*/
  border-radius: 0px;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 1px;
  /*outline: medium;*/
}
.goBackBtn{
  color: #123B7F;
  border-color: #123B7F;
}
.goBackBtn:hover{
  background-color: #123B7F;
  color: #FFFFFF;
}
</style>